import { getFetch, postFetchWithBody, postFetchWithToken } from "../../utils/fetch";

async function getOperators(page) {
  const res = await getFetch(`/Operator?${page}`);
  if (res.status !== "error") {
    return {
      status: "success",
      message: res,
    };
  } else {
    return {
      status: res.status,
      message: "خطا در اتصال به سرور!",
    };
  }
}
async function storeOperators(form) {
  if (form.get("name") === "") {
    return {
      status: "error",
      message: "نام و نام خانوادگی الزامی است!",
    };
  }
  if (form.get("melli_code") === "") {
    return {
      status: "error",
      message: "کدملی الزامی است!",
    };
  }
  if (form.get("cellphone") === "") {
    return {
      status: "error",
      message: "شماره موبایل الزامی است!",
    };
  }

  const res = await postFetchWithToken("/Operator/store", form);
  if (res.status !== "error") {
    return {
      status: "success",
      message: "اپراتور با موفقیت ایجاد شد",
    };
  } else {
    return {
      status: res.status,
      message: res.message,
    };
  }
}
async function deleteOperator(id) {
  const res = await postFetchWithBody(`/Operator/delete`, { id: id });
  if (res.status !== "error") {
    return {
      status: "success",
      message: res,
    };
  } else {
    return {
      status: res.status,
      message: "خطا در اتصال به سرور!",
    };
  }
}

export { storeOperators , getOperators,deleteOperator};
